import {
  Field as ChakraField,
  Input,
  InputProps,
  JsxHtmlProps,
  JsxStyleProps
} from "@chakra-ui/react"
import { LocalStorageOptions } from "@pathwright/utils/src/storage/useLocalStorage"
import useFormikDiscardFormState from "@pathwright/ux/src/components/form/state/useFormikDiscardFormState"
import { FormStateKey } from "@pathwright/ux/src/components/form/state/useFormStateStorage"
import { FieldConfig, Field as FormikField, useFormikContext } from "formik"
import Field from "../Field"

function FormikFormStateField<T extends JsxHtmlProps<any> & JsxStyleProps>(
  props: FieldConfig &
    T & {
      formStateKey?: FormStateKey
      localStorageOptions?: LocalStorageOptions
    }
): JSX.Element {
  const { formStateKey, localStorageOptions, ...passProps } = props

  useFormikDiscardFormState({
    keys: [props.name],
    formStateKey,
    localStorageOptions
  })

  return <Field {...passProps} />
}

export const FormikFormStateInputField: typeof FormikFormStateField<
  InputProps
> = (props) => <FormikFormStateField type="text" {...props} as={Input} />

// Alternate, made when testing issues with form state storage solely occurring in tests.
export function _FormikFormStateInputField(
  props: {
    name: string
    formStateKey: FormStateKey
    localStorageOptions?: LocalStorageOptions
  } & InputProps
) {
  const form = useFormikContext<{}>()
  const { formStateKey, localStorageOptions, ...passProps } = props

  useFormikDiscardFormState({
    keys: [props.name],
    formStateKey,
    localStorageOptions
  })

  return (
    <ChakraField.Root
      invalid={
        !!form.errors[props.name] &&
        form.touched[props.name] &&
        form.values[props.name] !== form.initialValues[props.name]
      }
    >
      <FormikField as={Input} id={props.name} variant="subtle" {...passProps} />
      <ChakraField.ErrorText>{form.errors[props.name]}</ChakraField.ErrorText>
    </ChakraField.Root>
  )
}

export default FormikFormStateField
